import VistaMesa from '@mui/icons-material/LocalLibrary';
import { Dialog, IconButton, Skeleton, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import VistaEmMesa from './VistaEmMesa';

class ModalVistaEmMesa extends ReactComponent {
    aberto = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            aberto: observable,
            registro: computed,
            toggleAberto: action,
            fechar: action,
            isCarregando: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    toggleAberto = () => {
        this.aberto = !this.aberto;
    };

    fechar = () => {
        this.aberto = false;
    };

    get isCarregando() {
        if (
            this.store.processoExpandido?.processo?.numeroCompleto &&
            this.store.processoExpandido.processo.numeroCompleto === this.registro?.processo?.numeroCompleto
        ) {
            const carregandoDetalhesProcesso = this.store.carregandoDetalhesProcesso.get(
                this.store.getChaveControleCarregamentoDetalhes(this.registro)
            );

            return !!(
                carregandoDetalhesProcesso?.carregando ||
                this.store.carregandoProcessos ||
                this.store.carregandoSessao
            );
        }

        return false;
    }

    renderLoading() {
        const tamanhoButtonIconSkeleton = 40;

        return (
            <Skeleton
                variant="rounded"
                width={tamanhoButtonIconSkeleton}
                height={tamanhoButtonIconSkeleton}
            />
        );
    }

    render() {
        if (this.isCarregando) {
            return this.renderLoading();
        }

        return (
            <>
                <IconButton
                    onClick={this.toggleAberto}
                    style={{ padding: '8px' }}
                    size="large"
                >
                    <Tooltip
                        placement="top"
                        title={<Typography>Registrar vista em mesa</Typography>}
                    >
                        <VistaMesa style={{ fill: '#000000' }} />
                    </Tooltip>
                </IconButton>
                {this.aberto && (
                    <Dialog
                        open={this.aberto}
                        onClose={this.fechar}
                        fullWidth={false}
                        maxWidth={'lg'}
                    >
                        <VistaEmMesa
                            fechar={this.fechar}
                            registro={this.registro}
                        />
                    </Dialog>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(ModalVistaEmMesa));
